import { atom } from "jotai";
import type { Stop } from "../types";

export const ticketMachinesRequestedLlAtom = atom<string | null>(null);

export const ticketMachinesEnabledAtom = atom(false);
export const ticketMachinesRequestedNameAtom = atom<string | null>(null);
export const ticketMachinesPoisAtom = atom<Stop[]>([]);

export const requestedTicketMachinePoiAtom = atom((get) => {
  const name = get(ticketMachinesRequestedNameAtom);
  const ll = parseLl(get(ticketMachinesRequestedLlAtom));
  const pois = get(ticketMachinesPoisAtom);

  if (pois.length === 0) return null;

  if (ll) {
    const byLl = findPoiByLl(pois, ll);
    if (byLl) return byLl;
  }

  if (!name) return null;

  return pois.find((p) => p.name === name) ?? null;
});

function parseLl(ll: string | null): { lat: number; lng: number } | null {
  if (!ll) return null;

  const [a, b] = ll.split(",").map((x) => Number(x.trim()));

  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;

  return { lat: a, lng: b };
}

function findPoiByLl(pois: Stop[], ll: { lat: number; lng: number }) {
  const tol = 0.001;

  let best: Stop | null = null;
  let bestD = Infinity;

  for (const p of pois) {
    const dLat = p.lat - ll.lat;
    const dLng = p.lng - ll.lng;

    if (Math.abs(dLat) > tol || Math.abs(dLng) > tol) continue;

    const d = dLat * dLat + dLng * dLng;

    if (d < bestD) {
      bestD = d;
      best = p;
    }
  }

  return best;
}
